import { FieldContainer } from '../functional'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import FormHelperText from '@mui/material/FormHelperText'
import Select, { SelectProps } from '@mui/material/Select'
import { ListSubheader } from '@mui/material'
import { color, font } from '../../styles'
import { linearGradient } from 'polished'

type SelectFieldProps = SelectProps & {
   name: string
   options: { value: string | number; label: string; groupName?: string }[]
   label: string
   highlight?: boolean
}

export const SelectField = ({ name, options, label, highlight, ...props }: SelectFieldProps) => {
   // check if the groupName property is present in the options array and if it is present in more than different groupNames
   const hasMultipleGroups =
      options.some((option) => option.groupName) &&
      options.some((option) => options.some((opt) => opt.groupName !== option.groupName))
   // get the index of the group in the options array
   const indexOfGroup = (groupName: string) => {
      return options?.findIndex((option) => option.groupName === groupName) as number
   }
   // create an array of {name:string, order:number } of the groups without duplicates, as the "order" is the index of the group in the "groupeNames" array, we can use the index of the group in the "groupeNames" array as the "order" value
   const groupNames = hasMultipleGroups
      ? options.reduce(
           (acc, option) => {
              if (!acc.some((group) => group.name === option.groupName)) {
                 acc.push({
                    name: option.groupName as string,
                    order: indexOfGroup(option.groupName as string),
                 })
              }
              return acc
           },
           [] as { name: string; order: number }[],
        )
      : undefined

   return (
      <FieldContainer name={name} highlight={highlight}>
         {(fieldProps) => {
            return (
               <FormControl
                  fullWidth
                  style={{ backgroundColor: 'transparent' }}
                  disabled={props.disabled || fieldProps.disabled}
                  error={fieldProps.error}
                  className={props.className}
               >
                  <InputLabel style={{ padding: '1% 3% 1% 7px', background: '#fff' }}>
                     {label}
                  </InputLabel>
                  <Select
                     MenuProps={{
                        container: document.querySelector('dialog') || undefined,
                        MenuListProps: {
                           style: {
                              display: 'flex',
                              flexDirection: 'column',
                           },
                        },
                     }}
                     {...fieldProps}
                     {...props}
                  >
                     {groupNames &&
                        groupNames.map(({ name: groupName, order }) => (
                           <ListSubheader
                              key={groupName}
                              style={{ order }}
                              className="sub-group-header"
                           >
                              {groupName}
                           </ListSubheader>
                        ))}
                     {options.map((option, index) => (
                        <MenuItem
                           key={option.value}
                           value={option.value}
                           style={{ order: index }}
                           className={`${!!groupNames ? 'sub-group-item' : ''}`}
                        >
                           {option.label}
                        </MenuItem>
                     ))}
                  </Select>
                  {fieldProps.helperText && (
                     <FormHelperText>{fieldProps.helperText}</FormHelperText>
                  )}
               </FormControl>
            )
         }}
      </FieldContainer>
   )
}

export default SelectField
